import { render, staticRenderFns } from "./marksChart.vue?vue&type=template&id=d33ed31e&"
import script from "./marksChart.vue?vue&type=script&lang=js&"
export * from "./marksChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports